export enum UserStatus {
   EXPIRED = "EXPIRED",
   EXPIREDDATE = "EXPIREDDATE",
   BLOCK = "BLOCK",
   ACTIVE = "ACTIVE",
}
